module.exports = __webpack_public_path__ + "static/img/7.b99d382.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/8/1/4/eng/7.png
// module id = g+BB
// module chunks = 0